const ITEMS = [
  {
    label: 'Jetson',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="4" y="6" width="16" height="12" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 10h8M8 14h5" stroke="currentColor" strokeWidth="1.4" />
      </svg>
    ),
  },
  {
    label: 'ROS 2',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="7" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="12" cy="12" r="2" fill="currentColor" />
        <circle cx="12" cy="5" r="1.2" fill="currentColor" />
        <circle cx="18" cy="15.5" r="1.2" fill="currentColor" />
        <circle cx="6" cy="15.5" r="1.2" fill="currentColor" />
      </svg>
    ),
  },
  {
    label: 'NVIDIA accelerated computing',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 4 20 8.5v7L12 20 4 15.5v-7L12 4z" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 8v8M8.5 10.2 15.5 14" stroke="currentColor" strokeWidth="1.2" />
      </svg>
    ),
  },
  {
    label: 'LiDAR',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <ellipse cx="12" cy="8" rx="6" ry="2.4" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M6 8v8c0 1.3 2.7 2.4 6 2.4s6-1.1 6-2.4V8" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 8v10.4" stroke="currentColor" strokeWidth="1.2" />
      </svg>
    ),
  },
  {
    label: 'Vision',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="3" y="7" width="14" height="10" rx="2" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M17 10.5 21 8v8l-4-2.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <circle cx="10" cy="12" r="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
      </svg>
    ),
  },
  {
    label: 'IMU',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 4v16M4 12h16" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 4l2.4 2.4M12 4 9.6 6.4M20 12l-2.4 2.4M20 12l-2.4-2.4" fill="none" stroke="currentColor" strokeWidth="1.4" />
      </svg>
    ),
  },
];

export default function BuiltWith() {
  return (
    <div className="bv-built-with">
      <span>Built with</span>
      <ul>
        {ITEMS.map((item) => (
          <li key={item.label}>
            {item.icon}
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
